import { render, staticRenderFns } from "./Account1Index.vue?vue&type=template&id=19ed59b8&scoped=true"
import script from "./Account1Index.vue?vue&type=script&lang=js"
export * from "./Account1Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ed59b8",
  null
  
)

export default component.exports